export const planTypes = {
  default: 0,
  chaptersPerDay: 1,
  quantityOfDays: 2,
};
